export const featureFlagConfig = {
  pollingInterval: 5 * 60 * 1000, // 5 minutes
  clientSdkKey: process.env.REACT_APP_FEATBIT_CLIENT_SDK_KEY || "",
  commonSdkKey: process.env.REACT_APP_FEATBIT_COMMON_SDK_KEY || "",
};

/** pdf.js worker file, served from public/. The version query makes browsers fetch the new worker after a pdfjs-dist update. */
export const getPdfWorkerSrc = (pdfjsVersion: string) => `${process.env.PUBLIC_URL}/pdf.worker.min.mjs?v=${pdfjsVersion}`;
